import { FC } from "react";

import { getFontStyleConfig } from "@/canvas/hooks/useFontStyleConfig";
import { useMediaQuery } from "@/common/hooks/useMediaQuery";
import { FORM_ELEMENT_IDS } from "@/features/LiveFormEditor/Steps/helpers/formStepToElementIdMap";
import { FormTypography, FormTypographyProps } from "@/forms-design-system/FormTypography/FormTypography";

type ThemedTitleProps = Omit<FormTypographyProps, "ref" | "variant" | "vibe" | "id" | "data-test"> & {
  titleFontStyle?: string | null;
};

export const ThemedTitle: FC<ThemedTitleProps> = ({ children, titleFontStyle, ...rest }) => {
  const { isSmallScreen } = useMediaQuery();
  const config = getFontStyleConfig(titleFontStyle);

  return (
    <FormTypography
      id={FORM_ELEMENT_IDS["title"]}
      data-test="form-title"
      variant="h4"
      vibe="intense"
      sx={{
        fontFamily: `${config.fontFamily} !important`,
        fontWeight: `${config.fontWeight} !important`,
        fontSize: isSmallScreen ? `${config.mobileFontSize} !important` : `${config.desktopFontSize} !important`,
        lineHeight: isSmallScreen ? `${config.mobileLineHeight} !important` : `${config.desktopLineHeight} !important`,
        transition: "font-size 0.2s ease-in, line-height 0.2s ease-in, font-weight 0.2s ease-in",
      }}
      {...rest}
    >
      {children}
    </FormTypography>
  );
};
